<template>
  <div>
    <pl-modal :visible="isOpenedNotificationsDialog" @close="closeDialog" max-width="500px">
      <v-layout column slot="content">
        <v-flex class="pointer pl-notifications__link" @click="checkTypeNotification(content)">
          {{ !!this.content.data ? this.content.data.message : '' }}
        </v-flex>
        <v-flex>Отправлено: {{ formatDate(this.content.created_at) }}</v-flex>
      </v-layout>
      <v-layout slot="footer" align-center justify-end row fill-height>
        <v-btn class="pl-btn pl-btn_default" @click="closeDialog">
          <v-icon class="mr-1">clear</v-icon>
          Закрыть
        </v-btn>
        <v-btn class="pl-btn pl-btn_primary" @click="markeAsRead">
          <v-icon class="mr-1">done</v-icon>
          Прочитано
        </v-btn>
      </v-layout>
    </pl-modal>
  </div>
</template>

<script>
import PLModal from '@/components/Modal/PLModal'
import Vue from 'vue'
import moment from 'moment'
import router from '@/router'

export default {
  name: 'dialogNotificationsInfo',
  components: {
    'pl-modal': PLModal,
  },
  props: {
    opened: {
      required: true,
    },
    content: {
      required: true,
    },
  },
  data: () => ({
    isOpenedNotificationsDialog: false,
    notificationDialogContent: {},
  }),
  methods: {
    closeDialog() {
      this.isOpenedNotificationsDialog = false
      this.$emit('closeNotificationsDialog')
    },
    markeAsRead() {
      this.$emit('markerAsRead', this.content.id)
      this.$emit('closeNotificationsDialog')
      this.isOpenedNotificationsDialog = false
    },
    formatDate(date) {
      return date ? moment(date).format(Vue.config.format.prettyDateFull) : null
    },
    checkTypeNotification(item) {
      console.log(item)

      switch (item.type) {
        case Vue.config.TYPE_NOTIFICATIONS.EMPLOYER:
          this.redirectEmployer(item.data.employer_id)
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.INTERVIEW:
          this.redirectEmployer(item.data.employer_id)
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.EMPLOYER_COMPLETE:
          this.redirectEmployer(item.data.employer_id)
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.TICKET_CREATED_MESSAGE:
          this.redirectTicket(item.data.ticket_id)
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.TICKET:
          this.redirectTicket(item.data.ticket_id)
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.GOOD_ORDER:
          this.redirectGoodOrder()
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.GOOD_FLOW:
          this.redirectGoodFlow(item.data.item_id)
          this.closeDialog()
          break

        case this.$config.TYPE_NOTIFICATIONS.CREATE_ORDER_TABLET:
          this.redirectOrder(item.data.order_id)
          this.closeDialog()
          break

        case this.$config.TYPE_NOTIFICATIONS.EXCEL_BOOKING:
          window.open(item.data.link, '_blank')
          this.closeDialog()
          break

        case Vue.config.TYPE_NOTIFICATIONS.NEWS:
          this.selectNews(item)
          this.closeDialog()
          break

        case this.$config.TYPE_NOTIFICATIONS.GENERATE_CERTIFICATE:
          this.$axios({
            url: `${this.$config.server}/api/crm/certificates/download/${item.data.batch}`,
            method: 'GET',
            responseType: 'blob',
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'certificates.txt')
            document.body.appendChild(link)
            link.click()
          })
          this.closeDialog()
          break

        default:
          if (item.data.link) {
            window.open(item.data.link, '_blank')
            this.closeDialog()
          }
          break
      }
    },
    redirectEmployer(employer_id) {
      return router.push({ path: Vue.config.modules.crm.route.employers.one.replace('$1', employer_id) })
    },
    redirectTicket(ticket_id) {
      return router.push({ path: Vue.config.modules.crm.route.tickets.one.replace('$1', ticket_id) })
    },
    redirectGoodOrder() {
      return router.push({ path: Vue.config.modules.crm.route.goodOrders.all })
    },
    redirectGoodFlow(item_id) {
      return router.push({ path: Vue.config.modules.crm.route.goodFlows.one.replace('$1', item_id) })
    },
    redirectOrder(id) {
      return router.push({ path: this.$config.modules.crm.route.finances.order.one.replace('$1', id) })
    },
    selectNews(item) {
      return this.$router.push({ name: 'notification', hash: item.id })
    },
  },
  watch: {
    opened(val) {
      if (val === true) {
        this.isOpenedNotificationsDialog = true
      }
    },
    content(val) {
      this.notificationDialogContent = val
    },
  },
}
</script>
